export default __webpack_public_path__ + "static/media/company_1.d011a42a.svg";